import { render, staticRenderFns } from "./RequestModal.vue?vue&type=template&id=2639052c&scoped=true&"
import script from "./RequestModal.vue?vue&type=script&lang=js&"
export * from "./RequestModal.vue?vue&type=script&lang=js&"
import style0 from "./RequestModal.vue?vue&type=style&index=0&id=2639052c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2639052c",
  null
  
)

component.options.__file = "RequestModal.vue"
export default component.exports